// extracted by mini-css-extract-plugin
export var measureBox = "_c1-0";